// File: frontend/src/mocks/reinsurance/claimsData.js

export const mockClaimsList = {
  success: true,
  count: 5,
  data: [
    {
      claim_id: "d1e2f3g4-h5i6-j7k8-l9m0-n1o2p3q4r5s6",
      claim_number: "CLM-250412-001",
      contract_id: "c8f9d2e1-6b7a-4c5d-8e3f-2a1b0c9d8e7f",
      contract_number: "RIL-240315-789",
      event: {
        event_name: "Hurricane Milton",
        event_date: "2025-04-10T00:00:00Z",
        event_type: "hurricane",
        event_parameters: {
          intensity: 4,
          location: {
            latitude: 25.7617,
            longitude: -80.1918,
            description: "Miami, Florida"
          },
          affected_area: "Florida East Coast",
          duration: 48
        },
        industry_loss: {
          estimated: 15000000000,
          actual: null,
          currency: "USD",
          source: "PCS"
        }
      },
      financials: {
        currency: "USD",
        initial_reserve: 3500000,
        current_reserve: 1750000,
        paid_to_date: 1750000,
        incurred_loss: 3500000,
        ultimate_loss_estimate: 3500000,
        recovery_estimate: 0,
        loss_adjustment_expenses: 250000,
        net_loss: 3500000,
        payment_history: [
          {
            payment_id: "e1f2g3h4-i5j6-k7l8-m9n0-o1p2q3r4s5t6",
            payment_date: "2025-04-20T00:00:00Z",
            payment_amount: 1750000,
            payment_currency: "USD",
            payment_type: "partial",
            payment_status: "paid"
          }
        ]
      },
      status: {
        current_status: "in_process",
        reported_date: "2025-04-12T10:15:00Z",
        settlement_date: null,
        closure_date: null,
        status_history: [
          {
            status: "reported",
            date: "2025-04-12T10:15:00Z",
            changed_by: "user123",
            reason: "Initial claim registration"
          },
          {
            status: "in_process",
            date: "2025-04-15T14:30:00Z",
            changed_by: "user456",
            reason: "Claim processing started"
          }
        ]
      }
    },
    {
      claim_id: "t7u8v9w0-x1y2-z3a4-b5c6-d7e8f9g0h1i2",
      claim_number: "CLM-250428-002",
      contract_id: "a7b6c5d4-e3f2-1g0h-9i8j-7k6l5m4n3o2p",
      contract_number: "RIL-240422-456",
      event: {
        event_name: "California Wildfire 2025",
        event_date: "2025-04-25T00:00:00Z",
        event_type: "wildfire",
        event_parameters: {
          intensity: null,
          location: {
            latitude: 34.0522,
            longitude: -118.2437,
            description: "Los Angeles County, California"
          },
          affected_area: "Southern California",
          duration: 72
        },
        industry_loss: {
          estimated: 8000000000,
          actual: null,
          currency: "USD",
          source: "PCS"
        }
      },
      financials: {
        currency: "USD",
        initial_reserve: 2800000,
        current_reserve: 2800000,
        paid_to_date: 0,
        incurred_loss: 2800000,
        ultimate_loss_estimate: 2800000,
        recovery_estimate: 0,
        loss_adjustment_expenses: 200000,
        net_loss: 2800000,
        payment_history: []
      },
      status: {
        current_status: "reported",
        reported_date: "2025-04-28T14:30:00Z",
        settlement_date: null,
        closure_date: null,
        status_history: [
          {
            status: "reported",
            date: "2025-04-28T14:30:00Z",
            changed_by: "user789",
            reason: "Initial claim registration"
          }
        ]
      }
    },
    {
      claim_id: "j3k4l5m6-n7o8-p9q0-r1s2-t3u4v5w6x7y8",
      claim_number: "CLM-250315-003",
      contract_id: "1a2b3c4d-5e6f-7g8h-9i0j-1k2l3m4n5o6p",
      contract_number: "RIL-240501-123",
      event: {
        event_name: "Tokyo Earthquake 2025",
        event_date: "2025-03-10T00:00:00Z",
        event_type: "earthquake",
        event_parameters: {
          intensity: 6.8,
          location: {
            latitude: 35.6762,
            longitude: 139.6503,
            description: "Tokyo, Japan"
          },
          affected_area: "Tokyo Metropolitan Area",
          duration: 1
        },
        industry_loss: {
          estimated: 12000000000,
          actual: null,
          currency: "USD",
          source: "SIGMA"
        }
      },
      financials: {
        currency: "USD",
        initial_reserve: 2500000,
        current_reserve: 1250000,
        paid_to_date: 1250000,
        incurred_loss: 2500000,
        ultimate_loss_estimate: 2500000,
        recovery_estimate: 0,
        loss_adjustment_expenses: 150000,
        net_loss: 2500000,
        payment_history: [
          {
            payment_id: "z9a0b1c2-d3e4-f5g6-h7i8-j9k0l1m2n3o4",
            payment_date: "2025-03-25T00:00:00Z",
            payment_amount: 1250000,
            payment_currency: "USD",
            payment_type: "partial",
            payment_status: "paid"
          }
        ]
      },
      status: {
        current_status: "in_process",
        reported_date: "2025-03-15T09:45:00Z",
        settlement_date: null,
        closure_date: null,
        status_history: [
          {
            status: "reported",
            date: "2025-03-15T09:45:00Z",
            changed_by: "user123",
            reason: "Initial claim registration"
          },
          {
            status: "in_process",
            date: "2025-03-18T11:20:00Z",
            changed_by: "user456",
            reason: "Claim processing started"
          }
        ]
      }
    },
    {
      claim_id: "p5q6r7s8-t9u0-v1w2-x3y4-z5a6b7c8d9e0",
      claim_number: "CLM-250220-004",
      contract_id: "c8f9d2e1-6b7a-4c5d-8e3f-2a1b0c9d8e7f",
      contract_number: "RIL-240315-789",
      event: {
        event_name: "Mississippi River Flooding",
        event_date: "2025-02-15T00:00:00Z",
        event_type: "flood",
        event_parameters: {
          intensity: null,
          location: {
            latitude: 38.6270,
            longitude: -90.1994,
            description: "St. Louis, Missouri"
          },
          affected_area: "Mississippi River Basin",
          duration: 120
        },
        industry_loss: {
          estimated: 5000000000,
          actual: null,
          currency: "USD",
          source: "PCS"
        }
      },
      financials: {
        currency: "USD",
        initial_reserve: 1500000,
        current_reserve: 750000,
        paid_to_date: 750000,
        incurred_loss: 1500000,
        ultimate_loss_estimate: 1500000,
        recovery_estimate: 0,
        loss_adjustment_expenses: 100000,
        net_loss: 1500000,
        payment_history: [
          {
            payment_id: "f1g2h3i4-j5k6-l7m8-n9o0-p1q2r3s4t5u6",
            payment_date: "2025-03-01T00:00:00Z",
            payment_amount: 750000,
            payment_currency: "USD",
            payment_type: "partial",
            payment_status: "paid"
          }
        ]
      },
      status: {
        current_status: "in_process",
        reported_date: "2025-02-20T13:10:00Z",
        settlement_date: null,
        closure_date: null,
        status_history: [
          {
            status: "reported",
            date: "2025-02-20T13:10:00Z",
            changed_by: "user789",
            reason: "Initial claim registration"
          },
          {
            status: "in_process",
            date: "2025-02-23T10:45:00Z",
            changed_by: "user456",
            reason: "Claim processing started"
          }
        ]
      }
    },
    {
      claim_id: "v7w8x9y0-z1a2-b3c4-d5e6-f7g8h9i0j1k2",
      claim_number: "CLM-250401-005",
      contract_id: "a7b6c5d4-e3f2-1g0h-9i8j-7k6l5m4n3o2p",
      contract_number: "RIL-240422-456",
      event: {
        event_name: "Australian Bushfire 2025",
        event_date: "2025-03-28T00:00:00Z",
        event_type: "wildfire",
        event_parameters: {
          intensity: null,
          location: {
            latitude: -33.8688,
            longitude: 151.2093,
            description: "New South Wales, Australia"
          },
          affected_area: "Eastern Australia",
          duration: 96
        },
        industry_loss: {
          estimated: 3000000000,
          actual: null,
          currency: "USD",
          source: "PERILS"
        }
      },
      financials: {
        currency: "USD",
        initial_reserve: 2200000,
        current_reserve: 2200000,
        paid_to_date: 0,
        incurred_loss: 2200000,
        ultimate_loss_estimate: 2200000,
        recovery_estimate: 0,
        loss_adjustment_expenses: 150000,
        net_loss: 2200000,
        payment_history: []
      },
      status: {
        current_status: "reported",
        reported_date: "2025-04-01T08:30:00Z",
        settlement_date: null,
        closure_date: null,
        status_history: [
          {
            status: "reported",
            date: "2025-04-01T08:30:00Z",
            changed_by: "user123",
            reason: "Initial claim registration"
          }
        ]
      }
    }
  ]
};

export const mockClaimDetails = {
  "d1e2f3g4-h5i6-j7k8-l9m0-n1o2p3q4r5s6": {
    success: true,
    data: {
      claim_id: "d1e2f3g4-h5i6-j7k8-l9m0-n1o2p3q4r5s6",
      claim_number: "CLM-250412-001",
      contract_id: "c8f9d2e1-6b7a-4c5d-8e3f-2a1b0c9d8e7f",
      contract_number: "RIL-240315-789",
      event: {
        event_name: "Hurricane Milton",
        event_date: "2025-04-10T00:00:00Z",
        event_type: "hurricane",
        event_parameters: {
          intensity: 4,
          location: {
            latitude: 25.7617,
            longitude: -80.1918,
            description: "Miami, Florida"
          },
          affected_area: "Florida East Coast",
          duration: 48
        },
        industry_loss: {
          estimated: 15000000000,
          actual: null,
          currency: "USD",
          source: "PCS"
        }
      },
      financials: {
        currency: "USD",
        initial_reserve: 3500000,
        current_reserve: 1750000,
        paid_to_date: 1750000,
        incurred_loss: 3500000,
        ultimate_loss_estimate: 3500000,
        recovery_estimate: 0,
        loss_adjustment_expenses: 250000,
        net_loss: 3500000,
        payment_history: [
          {
            payment_id: "e1f2g3h4-i5j6-k7l8-m9n0-o1p2q3r4s5t6",
            payment_date: "2025-04-20T00:00:00Z",
            payment_amount: 1750000,
            payment_currency: "USD",
            payment_type: "partial",
            payment_status: "paid"
          }
        ]
      },
      status: {
        current_status: "in_process",
        reported_date: "2025-04-12T10:15:00Z",
        settlement_date: null,
        closure_date: null,
        status_history: [
          {
            status: "reported",
            date: "2025-04-12T10:15:00Z",
            changed_by: "user123",
            reason: "Initial claim registration"
          },
          {
            status: "in_process",
            date: "2025-04-15T14:30:00Z",
            changed_by: "user456",
            reason: "Claim processing started"
          }
        ]
      },
      documentation: {
        proof_of_loss: {
          received: true,
          date_received: "2025-04-18T00:00:00Z",
          verified: true,
          verification_date: "2025-04-19T00:00:00Z"
        },
        supporting_documents: [
          {
            document_id: "doc1-2a3b-4c5d-6e7f8g9h0i1j",
            document_type: "claim_notice",
            document_name: "Initial Claim Notice.pdf",
            document_url: "https://example.com/documents/claim_notice_001.pdf",
            upload_date: "2025-04-12T10:30:00Z",
            uploaded_by: "user123"
          },
          {
            document_id: "doc2-3c4d-5e6f-7g8h9i0j1k2l",
            document_type: "proof_of_loss",
            document_name: "Proof of Loss.pdf",
            document_url: "https://example.com/documents/proof_of_loss_001.pdf",
            upload_date: "2025-04-18T09:15:00Z",
            uploaded_by: "user456"
          }
        ],
        correspondence: [
          {
            correspondence_id: "corr1-4e5f-6g7h-8i9j0k1l2m3n",
            correspondence_type: "email",
            correspondence_date: "2025-04-13T14:20:00Z",
            sender: "claims@globalinsurance.com",
            recipient: "claims@radixils.com",
            subject: "Hurricane Milton Claim - Additional Information",
            content: "Please find attached additional information regarding the Hurricane Milton claim.",
            attachments: ["Damage Assessment Report.pdf"]
          }
        ]
      },
      allocations: [
        {
          capital_id: "a1b2c3d4-e5f6-g7h8-i9j0-k1l2m3n4o5p6",
          investor_id: "j3k4l5m6-n7o8-p9q0-r1s2-t3u4v5w6x7y8",
          investor_name: "ILS Fund Alpha",
          allocation_percentage: 66.67,
          allocated_loss: 2333450,
          allocated_reserve: 1166725,
          allocated_payment: 1166725
        },
        {
          capital_id: "q7r8s9t0-u1v2-w3x4-y5z6-a7b8c9d0e1f2",
          investor_id: "j3k4l5m6-n7o8-p9q0-r1s2-t3u4v5w6x7y8",
          investor_name: "ILS Fund Alpha",
          allocation_percentage: 33.33,
          allocated_loss: 1166550,
          allocated_reserve: 583275,
          allocated_payment: 583275
        }
      ],
      assessment: {
        coverage_verification: {
          covered: true,
          verification_date: "2025-04-14T00:00:00Z",
          verified_by: "user456",
          exclusions_applied: [],
          special_conditions_applied: ["Claims Cooperation"]
        },
        loss_adjustment: {
          adjuster_name: "John Adams",
          adjustment_date: "2025-04-16T00:00:00Z",
          adjustment_report: "https://example.com/documents/adjustment_report_001.pdf",
          adjustment_findings: "Damage consistent with Category 4 hurricane. Estimated loss within policy limits."
        },
        dispute_information: {
          disputed: false,
          dispute_reason: null,
          dispute_date: null,
          resolution_status: null,
          resolution_date: null
        }
      },
      metadata: {
        created_at: "2025-04-12T10:15:00Z",
        updated_at: "2025-04-20T15:30:00Z",
        created_by: "user123",
        updated_by: "user456",
        version: 3,
        workflow_status: "in_progress",
        approval_status: "approved",
        notes: [
          "Initial reserve set based on preliminary damage assessment",
          "Partial payment approved after verification of proof of loss"
        ],
        tags: ["hurricane", "property", "florida", "2025"]
      }
    }
  }
};

export const mockRegisterClaimResponse = {
  success: true,
  message: "Claim registered successfully",
  data: {
    claim_id: "b9c0d1e2-f3g4-h5i6-j7k8-l9m0n1o2p3q4",
    claim_number: "CLM-250503-006",
    contract_id: "c8f9d2e1-6b7a-4c5d-8e3f-2a1b0c9d8e7f",
    contract_number: "RIL-240315-789",
    status: "reported"
  }
};

export const mockProcessClaimResponse = {
  success: true,
  message: "Claim processed successfully",
  data: {
    claim_id: "d1e2f3g4-h5i6-j7k8-l9m0-n1o2p3q4r5s6",
    claim_number: "CLM-250412-001",
    status: "in_process",
    incurred_loss: 3500000,
    current_reserve: 1750000
  }
};

export const mockSettleClaimResponse = {
  success: true,
  message: "Claim settled successfully",
  data: {
    claim_id: "d1e2f3g4-h5i6-j7k8-l9m0-n1o2p3q4r5s6",
    claim_number: "CLM-250412-001",
    status: "settled",
    paid_to_date: 3500000,
    settlement_date: "2025-05-03T10:45:00Z"
  }
};

export const mockClaimsReportResponse = {
  success: true,
  data: {
    report_date: "2025-05-03T10:30:00Z",
    claim_count: 5,
    total_incurred: 12500000,
    total_paid: 3750000,
    total_reserved: 8750000,
    claims_by_status: [
      {
        status: "in_process",
        count: 3,
        total_incurred: 7500000,
        total_paid: 3750000,
        total_reserved: 3750000
      },
      {
        status: "reported",
        count: 2,
        total_incurred: 5000000,
        total_paid: 0,
        total_reserved: 5000000
      }
    ],
    claims_by_event_type: [
      {
        event_type: "hurricane",
        count: 1,
        total_incurred: 3500000,
        total_paid: 1750000,
        total_reserved: 1750000
      },
      {
        event_type: "wildfire",
        count: 2,
        total_incurred: 5000000,
        total_paid: 0,
        total_reserved: 5000000
      },
      {
        event_type: "earthquake",
        count: 1,
        total_incurred: 2500000,
        total_paid: 1250000,
        total_reserved: 1250000
      },
      {
        event_type: "flood",
        count: 1,
        total_incurred: 1500000,
        total_paid: 750000,
        total_reserved: 750000
      }
    ],
    claims: [
      {
        claim_id: "d1e2f3g4-h5i6-j7k8-l9m0-n1o2p3q4r5s6",
        claim_number: "CLM-250412-001",
        contract_id: "c8f9d2e1-6b7a-4c5d-8e3f-2a1b0c9d8e7f",
        contract_number: "RIL-240315-789",
        event_name: "Hurricane Milton",
        event_date: "2025-04-10T00:00:00Z",
        event_type: "hurricane",
        current_status: "in_process",
        reported_date: "2025-04-12T10:15:00Z",
        incurred_loss: 3500000,
        paid_to_date: 1750000,
        current_reserve: 1750000
      },
      {
        claim_id: "t7u8v9w0-x1y2-z3a4-b5c6-d7e8f9g0h1i2",
        claim_number: "CLM-250428-002",
        contract_id: "a7b6c5d4-e3f2-1g0h-9i8j-7k6l5m4n3o2p",
        contract_number: "RIL-240422-456",
        event_name: "California Wildfire 2025",
        event_date: "2025-04-25T00:00:00Z",
        event_type: "wildfire",
        current_status: "reported",
        reported_date: "2025-04-28T14:30:00Z",
        incurred_loss: 2800000,
        paid_to_date: 0,
        current_reserve: 2800000
      },
      {
        claim_id: "j3k4l5m6-n7o8-p9q0-r1s2-t3u4v5w6x7y8",
        claim_number: "CLM-250315-003",
        contract_id: "1a2b3c4d-5e6f-7g8h-9i0j-1k2l3m4n5o6p",
        contract_number: "RIL-240501-123",
        event_name: "Tokyo Earthquake 2025",
        event_date: "2025-03-10T00:00:00Z",
        event_type: "earthquake",
        current_status: "in_process",
        reported_date: "2025-03-15T09:45:00Z",
        incurred_loss: 2500000,
        paid_to_date: 1250000,
        current_reserve: 1250000
      },
      {
        claim_id: "p5q6r7s8-t9u0-v1w2-x3y4-z5a6b7c8d9e0",
        claim_number: "CLM-250220-004",
        contract_id: "c8f9d2e1-6b7a-4c5d-8e3f-2a1b0c9d8e7f",
        contract_number: "RIL-240315-789",
        event_name: "Mississippi River Flooding",
        event_date: "2025-02-15T00:00:00Z",
        event_type: "flood",
        current_status: "in_process",
        reported_date: "2025-02-20T13:10:00Z",
        incurred_loss: 1500000,
        paid_to_date: 750000,
        current_reserve: 750000
      },
      {
        claim_id: "v7w8x9y0-z1a2-b3c4-d5e6-f7g8h9i0j1k2",
        claim_number: "CLM-250401-005",
        contract_id: "a7b6c5d4-e3f2-1g0h-9i8j-7k6l5m4n3o2p",
        contract_number: "RIL-240422-456",
        event_name: "Australian Bushfire 2025",
        event_date: "2025-03-28T00:00:00Z",
        event_type: "wildfire",
        current_status: "reported",
        reported_date: "2025-04-01T08:30:00Z",
        incurred_loss: 2200000,
        paid_to_date: 0,
        current_reserve: 2200000
      }
    ]
  }
};